function parseIsoDateString(isoDateString, defYear = NaN, defMonth = NaN, defDay = NaN) {
    const [yStr, mStr, dStr] = `${isoDateString}`.split("-")
    const year = parseInt(yStr, 10) || defYear
    const month = parseInt(mStr, 10) || defMonth
    const day = parseInt(dStr, 10) || defDay
    return { year, month, day }
}

function getDateParts(inputDate) {
    // getFullYear returns a number corresponding to the year of the given date, according to local time.
    // getMonth returns a number, between 0 and 11, representing the month in the given date.
    // getDate returns a number, between 1 and 31, representing the day of the month for the given date.

    const year = inputDate.getFullYear()
    const month = inputDate.getMonth() + 1 // add 1 to make it normal 1 - 12
    const day = inputDate.getDate()

    // start debug
    const params = new URLSearchParams(document.location.search.substring(1))
    const dateParam = params.get("date")
    if (dateParam) {
        return parseIsoDateString(dateParam, year, month, day)
        // onsole.debug("It's a FAKE date:", dateParam, " resolved to: ", {year, month, day})
    }
    // end debug

    return { year, month, day }
}

function isInRange(startIsoString, endIsoString, nowDate, debug = false) {
    const sp = parseIsoDateString(startIsoString)
    const ep = parseIsoDateString(endIsoString)
    const start = new Date(sp.year, sp.month - 1, sp.day, 0, 0, 0)
    const end = new Date(ep.year, ep.month - 1, ep.day, 23, 59, 59) // end of date to be inclusive

    const inRange = start < nowDate && nowDate < end
    if (debug) {
        console.debug("isInRange debug: ", {
            startIsoString,
            endIsoString,
            nowDate,
            start,
            end,
            inRange,
        })
    }
    return inRange
}

function isChristmasLeadUp(date) {
    const { month } = getDateParts(date)
    return month === 11
}

function isAdvent(date) {
    const { month, day } = getDateParts(date)
    return month === 12 && day < 25
}

function isChristmasCampaignTime(date) {
    return isAdvent(date) || isChristmasLeadUp(date)
}

function isWinter(date) {
    const { month } = getDateParts(date)
    return month >= 11 || month <= 3
}

function isNewYearCampaign(date) {
    const { month, day } = getDateParts(date)
    return month === 1 && day >= 3 && day <= 15
}

export {
    getDateParts,
    isChristmasCampaignTime,
    isAdvent,
    isChristmasLeadUp,
    isWinter,
    isNewYearCampaign,
    parseIsoDateString,
    isInRange,
}
